var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-modal",
    {
      attrs: { id: "modal", "hide-header": "", scrollable: "" },
      scopedSlots: _vm._u([
        {
          key: "modal-footer",
          fn: function() {
            return [
              _c(
                "b-button",
                {
                  attrs: { variant: "primary", size: "sm" },
                  on: {
                    click: function($event) {
                      _vm.modal = false
                    }
                  }
                },
                [_c("i", { staticClass: "fas fa-thumbs-up" }), _vm._v(" OK")]
              )
            ]
          },
          proxy: true
        }
      ]),
      model: {
        value: _vm.modal,
        callback: function($$v) {
          _vm.modal = $$v
        },
        expression: "modal"
      }
    },
    [_c("b-img", { attrs: { src: "/imgs/credsec.png", fluid: "" } })],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0d1b2b06", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0d1b2b06","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/util/HomeComunicado.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-0d1b2b06","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/util/HomeComunicado.vue
// module chunks = 2